import getQueryBuilderError from 'pages/rules/utils/getQueryBuilderError';
import validateData from 'components/modules/dmn/src/utils/validation';
import openNotificationWithIcon from 'core/utils/notification';
import constants from 'core/constants/Constants';
import convertToDMN from 'components/modules/dmn/src/utils/convertToDmn';
import validatePayoutFields from 'pages/rules/utils/validatePayoutFields';

const validateDmnAndQueryBuilder = ({
  ruleApplicabilty,
  ruleApplicabilityModeType,
  outputformula,
  outputFormulaModeType,
  state,
  value,
}) => {
  // Check if we're entering only a number or if configuration status is false
  const isOnlyNumber =
    value?.enter_amount && !outputformula?.query && !ruleApplicabilty?.query;
  const isGroupAdjustment =
    value?.adjustment_level === constants.adjustmentLevels.group;
  const isPartialClawback =
    value?.clawback_type === constants.clawbackTypes.partial;
  const simpleType = constants.payoutTypes
    .map((item) => item?.value)
    .includes(outputformula?.type);
  // Automatically determine rule_group_configuration_status
  let ruleGroupConfigurationStatus = true; // default to true
  // Set to false if:
  // 1. Entering only a number (no complex queries)
  // 2. Adjustment level is 'group'
  // 3. No DMN data or no output formula
  if (
    isOnlyNumber ||
    isGroupAdjustment ||
    isPartialClawback ||
    !state.dmnData ||
    !outputformula?.query
  ) {
    ruleGroupConfigurationStatus = false;
  }

  // Skip validation if entering only number or configuration status is false
  if (isOnlyNumber || ruleGroupConfigurationStatus === false) {
    return { isValid: true };
  }

  // Query builder error checks - only validate if not group adjustment
  if (!isGroupAdjustment || !isPartialClawback) {
    const isRuleApplicabilityError = getQueryBuilderError(
      ruleApplicabilty,
      ruleApplicabilityModeType
    );
    const isOutputFormulaError = getQueryBuilderError(
      outputformula,
      outputFormulaModeType
    );
    if (isRuleApplicabilityError && isOutputFormulaError) {
      state.setRuleApplicabilityError(true);
      state.setOutputFormulaError(true);
      return { isValid: false, errorType: 'both' };
    }
    if (isRuleApplicabilityError) {
      state.setRuleApplicabilityError(true);
      return { isValid: false, errorType: 'ruleApplicability' };
    }
    if (isOutputFormulaError && !simpleType && !isPartialClawback) {
      state.setOutputFormulaError(true);
      return { isValid: false, errorType: constants.ruleTabKeys.outputFormula };
    }

    if (simpleType) {
      const errors = validatePayoutFields(
        outputformula?.type,
        outputformula.fields
      );
      console.log(errors, 'simplePayouterror');
      if (Object.keys(errors)?.length > 0 || !outputformula?.type) {
        state.setOutputFormulaError(true);
        return {
          isValid: false,
          errorType: constants.ruleTabKeys.outputFormula,
        };
      }
    }
  }

  // DMN validation - only validate if not entering only number and not group adjustment
  if (!isOnlyNumber && !isGroupAdjustment && !simpleType) {
    const headers =
      Object.keys(state.dmnData?.data)?.length > 0 &&
      Object.keys(state.dmnData?.data?.[0]);
    const validateDmn = validateData(
      state.dmnData,
      headers,
      state.setValidationErrors
    );
    if (!validateDmn) {
      return { isValid: false, errorType: 'dmnValidation' };
    }

    // XML structure validation (sync, using state.xmlStructure)
    const xmlString = convertToDMN(state?.dmnData, value?.rule_name);
    if (!xmlString) {
      openNotificationWithIcon(
        constants.error,
        'Enter values for Input and Output Columns'
      );
      return { isValid: false, errorType: 'noXmlString' };
    }
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, 'text/xml');

    const inputElements = xmlDoc.getElementsByTagName('input');
    const inputNamesArray = [];
    for (let i = 0; i < inputElements?.length; i += 1) {
      const inputvalue = inputElements[i].getAttribute('label');
      inputNamesArray.push(inputvalue);
    }

    const labelExists = inputNamesArray.map((item) =>
      state.concatList?.some((data) => data.label === item)
    );

    const outputElements = xmlDoc.getElementsByTagName('output');
    const outputNamesArray = [];
    for (let i = 0; i < outputElements?.length; i += 1) {
      const outputvalue = outputElements[i].getAttribute('name');
      outputNamesArray.push(outputvalue);
    }
    if (labelExists.includes(false)) {
      state.setHasInvalidInputColumn(true);
      openNotificationWithIcon(constants.error, 'Invalid Input Column');
      return { isValid: false, errorType: 'invalidInputColumn' };
    }
  }

  // If all checks pass
  return { isValid: true };
};

export default validateDmnAndQueryBuilder;
